import { Grid } from "@mui/material";
import { useResponsive } from "../../Modulo_Responsive/Hooks/useResponsive";
import { Helmet } from "react-helmet";
import ListaMisterio from "./Componentes/SubComponentes/ListaMisterio";

const Seccion_Pagina_Misteriosa = () => {
    const { sCell } = useResponsive();

    return (
        <>
            <Helmet>
                <title>Página Misteriosa - Promociones y Actividades</title>
                <meta
                    name="description"
                    content="Explora nuestra Página Misteriosa, un espacio para promociones, retos, actividades y productos de temporada. Descubre contenido exclusivo."
                />
                <meta
                    name="keywords"
                    content="promociones, retos, actividades, productos de temporada, Página Misteriosa, contenido exclusivo"
                />
                <meta property="og:title" content="Página Misteriosa - Promociones y Actividades" />
                <meta property="og:description" content="Explora nuestra Página Misteriosa, un espacio para promociones, retos, actividades y productos de temporada. Descubre contenido exclusivo." />
                <meta property="og:type" content="website" />
            </Helmet>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
            >
                <Grid container size={{ xs: 12, sm: 12, md: 12 }}>
                    <ListaMisterio/>
                </Grid>
            </Grid>
        </>
    );
};

export default Seccion_Pagina_Misteriosa;
